import { wrapContained as withStyle } from 'utils/styles'

export default withStyle(
  () => `
    margin: 10px 0;
    strong {
      display: inline;

      svg {
        margin-left: 5px;
        vertical-align: middle;
      }
    }
  `
)
